import React from "react";

const HeadingSection = () => {
    return (
        <>
            <div className="dashboard__apiPlaygroundDetails">
                <h4>Use Case</h4>
                <p>This API is used for point redemption.</p>
                <div className="table-responsive">
                    <table className="table table-bordered w-100">
                        <thead>
                            <tr>
                                <th>ATTRIBUTE</th>
                                <th>VALUE</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Authorization string mandatory</td>
                                <td>This is a base64 encoded string of “clientId:clientSecret”</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="dashboard__apiPlaygroundDetails">
                <h4>Request Attributes</h4>
                <p>Content Type : JSON</p>
                <h4>Body</h4>
                <div className="table-responsive">
                    <table className="table table-bordered w-100">
                        <thead>
                            <tr>
                                <th>ATTRIBUTE</th>
                                <th>VALUE</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>"mobile"</td>
                                <td>Contact Number of Customer</td>
                            </tr>
                            <tr>
                                <td>"walletType"</td>
                                <td>Type of Redemption</td>
                            </tr>
                            <tr>
                                <td>"values"</td>
                                <td>Number of Points to be Redeem</td>
                            </tr>
                            <tr>
                                <td>"transactionType"</td>
                                <td>Redeem</td>
                            </tr>
                            <tr>
                                <td>"transactionDate"</td>
                                <td>Date of Redemption</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="dashboard__apiPlaygroundDetails">
                <h4>Response Attributes</h4>
                <p>API Content Type: JSON</p>
                <h4>Success Response</h4>
                <div className="table-responsive" style={{ margin: "0 0 30px" }}>
                    <table className="table table-bordered w-100">
                        <thead>
                            <tr>
                                <th>ATTRIBUTE</th>
                                <th>VALUE</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>"message"</td>
                                <td>Request Processed Successfully</td>
                            </tr>
                            <tr>
                                <td>"earnedValue"</td>
                                <td>value earned by qualifying the campaign</td>
                            </tr>
                            <tr>
                                <td>"earnedTransactionId"</td>
                                <td>transactionId based on successful Redemption</td>
                            </tr>
                            <tr>
                                <td>"transactionChannel"</td>
                                <td>Name of channel</td>
                            </tr>
                            <tr>
                                <td>"transactionMethodKey"</td>
                                <td>Name of Transaction Method key</td>
                            </tr>
                            <tr>
                                <td>"mobile"</td>
                                <td>contact number of customer(any ident)</td>
                            </tr>
                            <tr>
                                <td>"walletType"</td>
                                <td>transactionId based on successful Redemption</td>
                            </tr>
                            <tr>
                                <td>"currentTransactionId"</td>
                                <td>CurrentTransactionId based on successful Redemption</td>
                            </tr>
                            <tr>
                                <td>"redeemAmount"</td>
                                <td>Amount Redeemed</td>
                            </tr>
                            <tr>
                                <td>"responceMessage"</td>
                                <td>Wallet Amount Successfully Redeem</td>
                            </tr>
                            <tr>
                                <td>"result"</td>
                                <td>1</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h4>Failure Response</h4>
                <div className="table-responsive" style={{ margin: "0 0 30px" }}>
                    <table className="table table-bordered w-100">
                        <thead>
                            <tr>
                                <th>ATTRIBUTE</th>
                                <th>DESCRIPTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>error string</td>
                                <td>This is the error corresponding to a particular error description and is returned to the merchant. The different error codes corresponding to this API are mentioned below.</td>
                            </tr>
                            <tr>
                                <td>error_description string</td>
                                <td>This parameter is the error_description which contains information about the failure result.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="alert alert-primary" role="alert" style={{ margin: "0" }}>
                    <p style={{ margin: "0" }}>
                        <strong>Note:</strong>&nbsp;If Authorization header is incorrect then the response will not come and you will face HTTP Status code "401"
                    </p>
                </div>
            </div>
            <div className="dashboard__apiPlaygroundDetails">
                <h4>Response Codes & Messages</h4>
                <div className="table-responsive">
                    <table className="table table-bordered w-100">
                        <thead>
                            <tr>
                                <th>ResponseCode</th>
                                <th>Status</th>
                                <th>Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>200</td>
                                <td>SUCCESS</td>
                                <td>OK</td>
                            </tr>
                            <tr>
                                <td>400</td>
                                <td>FAILURE</td>
                                <td>Fail</td>
                            </tr>
                            <tr>
                                <td>401</td>
                                <td>FAILURE</td>
                                <td>Unauthorized Access</td>
                            </tr>

                            <tr>
                                <td>404</td>
                                <td>FAILURE</td>
                                <td>Not Found</td>
                            </tr>

                            <tr>
                                <td>415</td>
                                <td>FAILURE</td>
                                <td>Unsupporetd Media Type</td>
                            </tr>
                            <tr>
                                <td>500</td>
                                <td>FAILURE</td>
                                <td>Internal Server Error</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default HeadingSection;
